import React from "react";

import TagIcon from "../TagIcon/TagIcon";
import {Tag, TagSize} from "../interfaces";
import styles from "./InlineTagList.scss";

type InlineTagListProps = {
  tags: Tag[];
  showName?: boolean;
  showTooltip?: boolean;
  size?: TagSize;
};

export default function InlineTagList({
  tags,
  showName,
  showTooltip,
  size,
}: InlineTagListProps): JSX.Element {
  return (
    <span className={styles.tagsContainer}>
      {tags.map((tag) => (
        <TagIcon
          key={tag.id}
          tag={tag}
          showName={showName}
          showTooltip={showTooltip}
          size={size}
        />
      ))}
    </span>
  );
}
